import type { User } from '@models/user.interface';

export function hasAdminRole(user: User | null | undefined): boolean {
  return (user?.rolesObject ?? []).some((role) => {
    const roleKey = String(role.role_key ?? role.catalogRoleObject?.role_key ?? '')
      .trim()
      .toUpperCase();

    return roleKey === 'ADMIN';
  });
}
